export default __webpack_public_path__ + "static/media/13.a7bbc972.png";